/**
 * Mobile detection utilities for touch-friendly interactions
 */

/**
 * Detect if the current device has touch support
 */
export function hasTouchSupport(): boolean {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

/**
 * Detect if the current device is mobile based on user agent
 * Note: Modern iPadOS may report desktop user agent
 */
export function isMobile(): boolean {
  const userAgent = navigator.userAgent.toLowerCase();

  // Check for mobile device patterns in user agent
  const mobilePatterns = [
    /android/,
    /webos/,
    /iphone/,
    /ipad/,
    /ipod/,
    /blackberry/,
    /iemobile/,
    /opera mini/,
    /mobile/,
    /tablet/,
  ];

  return mobilePatterns.some((pattern) => pattern.test(userAgent));
}
